import { api, CHAT_DOCUMENTS_TAG } from '@/api';
import { serializeChatDocumentIds } from './serializeChatDocumentIds';

export interface PostChatDocumentBulkUploadCompleteRequest {
  chatDocumentIds: string[];
}

const chatDocumentBulkUploadCompleteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postChatDocumentBulkUploadComplete: builder.mutation<void, PostChatDocumentBulkUploadCompleteRequest>({
      query: ({ chatDocumentIds }) => ({
        url: '/chat/document/bulk-upload-complete',
        method: 'POST',
        body: { chatDocumentIds: serializeChatDocumentIds(chatDocumentIds) },
      }),
      invalidatesTags: () => [{ type: CHAT_DOCUMENTS_TAG, id: 'LIST' }],
    }),
  }),
});

export const { usePostChatDocumentBulkUploadCompleteMutation } = chatDocumentBulkUploadCompleteApi;
